import CargoShipperSuccessFcl from "./cargo-shipper-success-fcl.container";

export default CargoShipperSuccessFcl;
